export const modulo10: any = (datos: string): number => {
  let calc = 0;
  let i;
  let j;
  let arr = [2, 1, 2, 1, 2, 1, 2, 1, 2];

  for (i = 0; i < datos.length; i += 1) {
    let calcTmp = Number(datos.charAt(i)) * arr[i];
    if (calcTmp > 9) {
      let tmp = 0;
      const str = calcTmp.toString();
      for (j = 0; j < str.length; j += 1) {
        tmp += +str.charAt(j);
      }
      calcTmp = tmp;
    }

    calc += +calcTmp;
  }

  const residuo = calc % 10;
  return residuo === 0 ? 0 : 10 - residuo;
};

export const modulo119: any = (datos: string): number => {
  let calc = 0;
  let i;
  let j;
  let arr = [4, 3, 2, 7, 6, 5, 4, 3, 2];

  for (i = 0; i < datos.length; i += 1) {
    let calcTmp = Number(datos.charAt(i)) * arr[i];
    if (calcTmp > 9) {
      let tmp = 0;
      const str = calcTmp.toString();
      for (j = 0; j < str.length; j += 1) {
        tmp += +str.charAt(j);
      }
      calcTmp = tmp;
    }

    calc += +calcTmp;
  }

  const residuo = calc % 10;
  return residuo === 0 ? 0 : 10 - residuo;
};

export const modulo116: any = (datos: string): number => {
  let calc = 0;
  let i;
  let j;
  let arr = [3, 2, 7, 6, 5, 4, 3, 2];

  for (i = 0; i < datos.length; i += 1) {
    let calcTmp = Number(datos.charAt(i)) * arr[i];
    if (calcTmp > 9) {
      let tmp = 0;
      const str = calcTmp.toString();
      for (j = 0; j < str.length; j += 1) {
        tmp += +str.charAt(j);
      }
      calcTmp = tmp;
    }

    calc += +calcTmp;
  }

  const residuo = calc % 10;
  return residuo === 0 ? 0 : 10 - residuo;
};
